// HeroSection.js
import React from 'react';
import { Link } from 'react-scroll';
import '../styles/HeroSection.css';

function HeroSection() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-content" data-aos="fade-right">
        <h1>Tap, Share, Go</h1>
        <h2>Revolutionize your branding with KonnectTaps</h2>
        <p>
          Elevate your networking with customizable digital pages and innovative smart NFC business cards.
        </p>
        <a href="https://ktaps.me" target="_blank" rel="noopener noreferrer" className="cta-button">
          Sign Up Now
        </a>
        <p className='free-text'>
          Free and will always be.
        </p>
      </div>

      <div className="hero-image" data-aos="fade-left">
        <img src="/images/hero-image.jpg" alt="Networking with KonnectTaps" />
      </div>
    </section>
  );
}

export default HeroSection;